import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import { cn } from '@/lib/utils';

interface NavItem {
  title: string;
  href: string;
  icon: string;
}

export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation('common');

  const navItems: NavItem[] = [
    {
      title: t('nav.dashboard'),
      href: '/dashboard',
      icon: 'dashboard',
    },
    {
      title: t('nav.projects'),
      href: '/projects',
      icon: 'view_kanban',
    },
    {
      title: t('nav.issues'),
      href: '/issues',
      icon: 'bug_report',
    },
    {
      title: t('nav.testPlans'),
      href: '/test-plans',
      icon: 'assignment_turned_in',
    },
    {
      title: t('nav.documents'),
      href: '/documents',
      icon: 'description',
    },
  ];

  return (
    <div className="md:hidden">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('nav.toggleMenu')}
      >
        {isOpen ? (
          <Icon name="close" className="h-5 w-5" />
        ) : (
          <Icon name="menu" className="h-5 w-5" />
        )}
      </Button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40 bg-black/50" onClick={() => setIsOpen(false)} />
          <nav className="fixed left-0 top-16 z-50 h-[calc(100vh-4rem)] w-64 border-r border-border bg-background p-4">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground',
                      isActive ? 'bg-accent text-accent-foreground' : 'text-muted-foreground',
                    )
                  }
                >
                  <Icon name={item.icon} className="h-5 w-5 shrink-0" />
                  <span>{item.title}</span>
                </NavLink>
              ))}
            </div>
          </nav>
        </>
      )}
    </div>
  );
}
